<template>
  <div class="total-container">
    <div v-if="!['/MultiChannelVideo', '/NewPlan'].includes($route.path)" class="total-header">
      <div class="header-left">海舶智慧渔业</div>
      <div class="header-center">
        <div class="center-menu" v-for="item in menuList" :key="item.label" style="cursor: pointer;"
          @click="selectMenu(item)">
          <div v-if="activeMenu == item.label" class="active-select">{{ item.label }}</div>
          <div v-else class="menu-item">
            {{ item.label }}</div>
        </div>
      </div>
      <div class="header-right">
        <div class="header-right-one">
          <div class="header-right-time">
            <div class="header-right-time1">
              {{ timenow ?? '--' }}</div>
            <div class="header-right-time2">
              {{ timedate ?? '--' }}</div>
          </div>

          <div class="header-right-line"></div>
          <div class="header-right-weather">
            <div v-if="weatherPic[weather?.weather]" class="header-right-weather-left">
              <img :src="weatherPic[weather?.weather]" style="width: 85%;height: 85%;">
            </div>
            <div class="header-right-weather-right">
              <div class="header-right-weather-right-text">
                {{ weather?.weather ?? '--' }}</div>
              <div class="header-right-weather-right-tempurtrue">
                {{ weather?.temperature ?? '--' }} °C</div>
            </div>
          </div>
        </div>

        <ah-pop placement="bottom">
          <template #content>
            <div class="route-btn-out" @click="aquaLogout">退出登录</div>
          </template>
          <div class="header-right-user">
            <img src="@/assets/avatar.png" />
            <div>{{ username }}</div>
          </div>
        </ah-pop>
      </div>
    </div>
    <div class="total-bottom">
      <sub-view-main></sub-view-main>
    </div>
  </div>
</template>

<script>
import SubViewMain from './SubViewMain.vue';
import router from '@/router';
import AhPop from "@/components/AhPop.vue";

export default {
  name: 'HomeView',
  components: {
    SubViewMain, AhPop
  },
  data() {
    return {
      timeSetinterval: null,
      timenow: "",
      timedate: "",
      // 配置经纬度（可根据需要修改，示例为上海经纬度）
      latitude: 31.2304,
      longitude: 121.4737,
      menuList: [{
        icon_on: require("@/assets/realtime/menu-realtime-on.png"),
        icon_un: require("@/assets/realtime/menu-realtime-un.png"),
        label: "态势控制",
        url: "/RealTime"
      },
      {
        icon_on: require("@/assets/realtime/menu-route-on.png"),
        icon_un: require("@/assets/realtime/menu-route-un.png"),
        label: "协同调度",
        url: "/CollaborativeScheduling"
      },
      {
        icon_on: require("@/assets/realtime/menu-route-on.png"),
        icon_un: require("@/assets/realtime/menu-route-un.png"),
        label: "全链路溯源",
        url: "/FullChainTraceability"
      },
      {
        icon_on: require("@/assets/realtime/menu-media-on.png"),
        icon_un: require("@/assets/realtime/menu-media-un.png"),
        label: "渔业服务",
        url: "/FisheryServices"
      },
      {
        icon_on: require("@/assets/realtime/menu-media-on.png"),
        icon_un: require("@/assets/realtime/menu-media-un.png"),
        label: "媒体库",
        url: "/Media"
      }],
      activeMenu: "态势控制",
      weather: {},
      // 映射Open-Meteo的天气代码到中文和图标
      weatherCodeMap: {
        0: { text: "晴", icon: "晴" },
        1: { text: "晴", icon: "晴" },
        2: { text: "多云", icon: "多云" },
        3: { text: "阴", icon: "阴" },
        45: { text: "霾", icon: "霾" },
        48: { text: "霾", icon: "霾" },
        51: { text: "雨", icon: "雨" },
        53: { text: "雨", icon: "雨" },
        55: { text: "雨", icon: "雨" },
        56: { text: "雨", icon: "雨" },
        57: { text: "雨", icon: "雨" },
        61: { text: "雨", icon: "雨" },
        63: { text: "雨", icon: "雨" },
        65: { text: "雨", icon: "雨" },
        66: { text: "雨", icon: "雨" },
        67: { text: "雨", icon: "雨" },
        71: { text: "雪", icon: "雪" },
        73: { text: "雪", icon: "雪" },
        75: { text: "雪", icon: "雪" },
        77: { text: "雪", icon: "雪" },
        80: { text: "雨", icon: "雨" },
        81: { text: "雨", icon: "雨" },
        82: { text: "雨", icon: "雨" },
        85: { text: "雪", icon: "雪" },
        86: { text: "雪", icon: "雪" },
        95: { text: "雨", icon: "雨" },
        96: { text: "雨", icon: "雨" },
        99: { text: "雨", icon: "雨" }
      },
      weatherPic: {
        "霾": require("@/assets/realtime/weather-dust.png"),
        "雨": require("@/assets/realtime/weather-rain.png"),
        "雪": require("@/assets/realtime/weather-snow.png"),
        "阴": require("@/assets/realtime/weather-overcast.png"),
        "晴": require("@/assets/realtime/weather-sunny.png"),
        "多云": require("@/assets/realtime/weather-cloudy.png"),
      },
      username: "",
      herdershowflag: "",
      beginPositionWatchTimer: null,
      weatherUpdateTimer: null, // 新增：天气定时更新器
    }
  },
  created() {
    this.getWeatherMsg();
    this.reRoute();
    this.timeSetinterval = setInterval(() => {
      this.updateTime();
    }, 1000);

    if (sessionStorage.getItem("user")) {
      console.log(sessionStorage.getItem("user"))
      this.username = JSON.parse(sessionStorage.getItem("user")).name;
    } else {
      window.location.href = "/login";
    }

    this.watchBeginPosition();
    this.startWeatherAutoUpdate(); // 新增：启动半小时自动更新天气
  },
  mounted() {
    this.setLatLngFromStorage();
  },
  beforeUnmount() {
    clearInterval(this.timeSetinterval);
    if (this.beginPositionWatchTimer) {
      clearInterval(this.beginPositionWatchTimer);
    }
    if (this.weatherUpdateTimer) {
      clearInterval(this.weatherUpdateTimer); // 新增：销毁天气定时器
    }
  },
  watch: {
    $route(to, from) {
      console.log("route", from, to)
      this.herdershowflag = to.fullPath
      this.reRoute();
    }
  },
  methods: {
    updateTime() {
      // 获取当前时间（格式 10:03:20）
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      this.timenow = `${hours}:${minutes}:${seconds}`;

      // 获取当前日期（格式 2025-06-16）
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
      const day = String(now.getDate()).padStart(2, '0');
      this.timedate = `${year}-${month}-${day}`;
    },

    aquaLogout() {
      sessionStorage.clear();
      window.location.href = "/login";
    },

    // 使用Open-Meteo API获取天气数据
    async getWeatherMsg() {
      try {
        // 构建请求URL
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${this.latitude}&longitude=${this.longitude}&current_weather=true`;

        // 发送请求
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP错误，状态码：${response.status}`);
        }

        const data = await response.json();

        // 解析天气数据并适配原有格式
        const currentWeather = data.current_weather;
        const weatherInfo = this.weatherCodeMap[currentWeather.weathercode] || { text: "未知", icon: "晴" };

        // 组装适配原有界面的天气数据
        this.weather = {
          weather: weatherInfo.text,    // 中文天气描述
          temperature: currentWeather.temperature.toFixed(1), // 温度（保留1位小数）
          reporttime: new Date().toLocaleString() // 上报时间
        };
        console.log("thisweather",this.latitude,this.longitude,this.weather);

        // 存储到sessionStorage
        sessionStorage.setItem("weather", JSON.stringify(this.weather));

      } catch (error) {
        console.error("获取天气数据失败：", error);
        // 异常处理：使用默认数据
        this.weather = {
          weather: "--",
          temperature: "--",
          reporttime: new Date().toLocaleString()
        };
        sessionStorage.setItem("weather", JSON.stringify(this.weather));
      }
    },

    // 新增：半小时自动更新天气（30 * 60 * 1000 = 30分钟）
    startWeatherAutoUpdate() {
      this.weatherUpdateTimer = setInterval(() => {
        this.getWeatherMsg();
      }, 30 * 60 * 1000);
    },

    selectMenu(item) {
      if (this.activeMenu != item.label) {
        this.activeMenu = item.label;
        this.$route.path = item.url;
        router.push(item.url);
      }
    },

    reRoute() {
      if (this.$route.path == "/") {
        this.$route.path = this.menuList[0].url;
        router.push(this.menuList[0].url);
      } else {
        this.activeMenu = this.$name;
      }
    },

    // 从 sessionStorage 读取并设置经纬度
    setLatLngFromStorage() {
      const pos = sessionStorage.getItem("beginPosition");
      console.log('deviceopenflag', pos);
      if (!pos) return;

      try {
        // 分割字符串，转成数字
        const [lng, lat] = pos.split(',').map(Number);

        this.longitude = lng;  // 经度
        this.latitude = lat;   // 纬度

        this.getWeatherMsg(); // 重新获取天气
        console.log('deviceopenflaglll 经纬度：', this.longitude, this.latitude);
      } catch (e) {
        console.error("解析 beginPosition 失败", e);
      }
    },

    // 监听 sessionStorage 中的 beginPosition 变化
    watchBeginPosition() {
      let lastPos = sessionStorage.getItem("beginPosition");

      this.beginPositionWatchTimer = setInterval(() => {
        const newPos = sessionStorage.getItem("beginPosition");
        if (newPos !== lastPos) {
          lastPos = newPos;
          this.setLatLngFromStorage(); // 更新经纬度并刷新天气
        }
      }, 1000); // 每秒检查一次
    }
  }
}
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}

.total-container {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;

  .total-header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 64px;
    line-height: 64px;
    background: linear-gradient(to top, rgba(131, 247, 172, 0.1) 0%, rgba(131, 247, 172, 0) 80%);
    color: #ffffff;
    z-index: 3000;
    border-bottom: 2px solid rgba(29, 151, 108, 0.4);

    .header-left {
      width: 23%;
      min-width: 366px;
      font-family: PangMenZhengDao;
      font-size: 32px;
      color: #FFFFFF;
      line-height: 64px;
      letter-spacing: 10px;
      padding-left: 49px;
      text-align: left;
      font-style: normal;
      background-image: url("@/assets/route/heade-left.png");
      background-size: 100% 100% !important;
      background-position: left;
      background-repeat: no-repeat;
    }

    .header-center {
      display: flex;
      flex-direction: row;
      height: 100%;
      min-width: 330px;
      justify-content: space-between;

      .center-menu {
        display: flex;
        flex-direction: row;
        height: 100%;

        .active-select {
          font-family: PangMenZhengDao;
          font-size: 16px;
          color: #FFFFFF;
          text-align: center;
          font-style: normal;
          width: 149px !important;
          height: 62px;
          background-image: url("@/assets/route/selectactive.svg");
          background-size: cover !important;
          background-position: center;
          background-repeat: no-repeat;
        }

        .menu-img {
          display: block;
          margin-top: 10px;
          padding-bottom: 5px;
          height: 20px;
          width: auto;
          max-width: 100%;
          margin-right: 20px;
        }
      }
    }

    .header-right {
      padding-right: 1rem;
      display: flex;
      flex-direction: row;
      height: 64px;
      width: 23%;
      min-width: 328px;
      justify-content: end;
      align-items: center;
      padding-top: 15px;
      padding-bottom: 15px;

      .header-right-one {
        height: 33px;
        display: flex;
        justify-content: start;
        align-items: center;

        .header-right-time {
          width: 68px;
          height: 33px;

          .header-right-time1 {
            width: 100%;
            height: 17px;
            font-family: PangMenZhengDao;
            font-size: 0.4rem;
            color: #FFFFFF;
            line-height: 17px;
            text-align: right;
            font-style: normal;
          }

          .header-right-time2 {
            width: 100%;
            height: 17px;
            font-family: D, D;
            font-weight: normal;
            font-size: 0.3rem;
            color: #FFFFFF;
            line-height: 17px;
            text-align: right;
            font-style: normal;
          }
        }
      }
    }

    .header-right-line {
      width: 24px;
      border-right: 3px solid #6F6F6F;
      height: 24px;
    }

    .total-bottom {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: row;
      overflow: hidden;

      .total-left {
        height: 100%;
        border-right: 1px solid #dcdfe6;
        width: 240px;

        .total-left-header {
          padding: 20px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
      }

      .total-main {
        flex: 1;
        width: calc(100% - 300px);
        padding: 5px 20px;
        background: #f8f8f8;

        .total-main-bar {
          height: 20px;
          border-radius: 5px;
          width: calc(100%)
        }
      }
    }
  }
}

.menu-item {
  font-family: PangMenZhengDao;
  font-size: 16px;
  color: #969696;
  text-align: center;
  font-style: normal;
  width: 149px !important;
}

.route-btn-out {
  background: #343434;
  cursor: pointer;
  text-align: center;
  height: 33px;
  line-height: 33px;
  font-size: 14px;
  width: 100%;
}

.header-right-weather {
  height: 33px;
  padding-left: 0.3rem;
  display: flex;
  justify-content: end;
  align-items: center;
  padding-right: 0.2rem;
  min-width: 2.4rem;

  .header-right-weather-left {
    width: 0.6rem;
    height: 0.6rem;
    line-height: 0.6rem;
  }
}

.header-right-weather-right {
  max-width: 100px;
  height: 33px;
}

.header-right-weather-right-text {
  max-width: 3rem;
  height: 17px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 0.3rem;
  color: #FFFFFF;
  line-height: 17px;
  text-align: right;
  font-style: normal;
}

.header-right-user {
  display: flex;
  height: 33px;
  justify-content: start;
  align-items: center;
  font-size: 0.4rem;
  min-width: 4rem;

  img {
    margin: 9px 10px 11px 10px;
    width: 0.6rem;
  }
}

.header-right-weather-right-tempurtrue {
  height: 16px;
  max-width: 90px;
  font-family: PangMenZhengDao;
  font-size: 0.45rem;
  color: #FFFFFF;
  line-height: 18px;
  text-align: left;
  font-style: normal;
}
</style>